<template>
    <div class="govuk-notification-banner" role="region"
        aria-labelledby="govuk-notification-banner-title"
        data-module="govuk-notification-banner"
        v-if="showBanner && banner">
        <div class="govuk-notification-banner__header row">
            <h2 class="govuk-notification-banner__title" id="govuk-notification-banner-title">
                Hysbysu
            </h2>
            <button 
                class="btn"
                @click="closeBanner"
                @keyup.enter="closeBanner"
                aria-label="clickable close site information"
            >
                <i class="fa fa-times-circle wn-icon"
                ></i>
            </button>
        </div>
        <div class="govuk-notification-banner__content">
            <p class="govuk-notification-banner__heading">
            Nid ydym yn gallu cyfieithu'r astudiaethau a restrir ar y wefan hon i'r Gymraeg.
            </p>
        </div>
       
    </div>
</template>
  
<script>
export default{
    data: () => ({
        banner : true
  }),
    computed:{
        showBanner(){
            // is welsh and button not been pressed
            const langID = new URLSearchParams(window.location.search).get("language_id");
            return langID && (langID !='1')
        },
    },
    methods:{
        closeBanner(){
            console.log(this.banner)
           return this.banner = false;
        },
    }
    

}
</script>
<style lang="scss" scoped >
.wn-icon{
    color:white;
}
.govuk-notification-banner {
-webkit-font-smoothing: antialiased;
-moz-osx-font-smoothing: grayscale;
font-weight: 400;
font-size: 16px;
font-size: 1rem;
line-height: 1.25;
margin-bottom: 0px;
border: 5px solid #1d70b8;
background-color: #1d70b8;
}
@media print {
.govuk-notification-banner {
font-family: sans-serif;
}
}
@media (min-width: 40.0625em) {
.govuk-notification-banner {
font-size: 19px;
font-size: 1.1875rem;
line-height: 1.31579;
}
}
@media print {
.govuk-notification-banner {
font-size: 14pt;
line-height: 1.15;
}
}
@media (min-width: 40.0625em) {
.govuk-notification-banner {
margin-bottom: 0px;
}
}
.govuk-notification-banner:focus {
outline: 3px solid #fd0;
}
.govuk-notification-banner__header {
padding: 2px 15px 5px;
border-bottom: 1px solid rgba(0, 0, 0, 0);
justify-content: space-between;
}
@media (min-width: 40.0625em) {
.govuk-notification-banner__header {
padding: 2px 20px 5px;
}
}
.govuk-notification-banner__title {
-webkit-font-smoothing: antialiased;
-moz-osx-font-smoothing: grayscale;
font-weight: 700;
font-size: 16px;
font-size: 1rem;
line-height: 1.25;
margin: 0;
padding: 0;
color: #fff;
}
@media print {
.govuk-notification-banner__title {
font-family: sans-serif;
}
}
@media (min-width: 40.0625em) {
.govuk-notification-banner__title {
font-size: 19px;
font-size: 1.1875rem;
line-height: 1.31579;
}
}
@media print {
.govuk-notification-banner__title {
font-size: 14pt;
line-height: 1.15;
}
}
.govuk-notification-banner__content {
color: #0b0c0c;
padding: 15px;
background-color: #fff;
}
@media print {
.govuk-notification-banner__content {
color: #000;
}
}
@media (min-width: 40.0625em) {
.govuk-notification-banner__content {
padding: 20px;
}
}
.govuk-notification-banner__content > * {
box-sizing: border-box;
max-width: 605px;
}
.govuk-notification-banner__content > :last-child {
margin-bottom: 0;
}
.govuk-notification-banner__heading {
-webkit-font-smoothing: antialiased;
-moz-osx-font-smoothing: grayscale;
font-weight: 700;
font-size: 18px;
font-size: 1.125rem;
line-height: 1.11111;
margin: 0 0 15px;
padding: 0;
}
@media print {
.govuk-notification-banner__heading {
font-family: sans-serif;
}
}
@media (min-width: 40.0625em) {
.govuk-notification-banner__heading {
font-size: 24px;
font-size: 1.5rem;
line-height: 1.25;
}
}
@media print {
.govuk-notification-banner__heading {
font-size: 18pt;
line-height: 1.15;
}
}
.govuk-notification-banner__link {
-webkit-font-smoothing: antialiased;
-moz-osx-font-smoothing: grayscale;
text-decoration: underline;
}
@media print {
.govuk-notification-banner__link {
font-family: sans-serif;
}
}
.govuk-notification-banner__link:focus {
outline: 3px solid rgba(0, 0, 0, 0);
background-color: #fd0;
box-shadow: 0 -2px #fd0, 0 4px #0b0c0c;
text-decoration: none;
}
.govuk-notification-banner__link:link,
.govuk-notification-banner__link:visited {
color: #1d70b8;
}
.govuk-notification-banner__link:hover {
color: #003078;
}
.govuk-notification-banner__link:active,
.govuk-notification-banner__link:focus {
color: #0b0c0c;
}
.govuk-notification-banner--success {
border-color: #00703c;
background-color: #00703c;
}
.govuk-notification-banner--success .govuk-notification-banner__link:link,
.govuk-notification-banner--success .govuk-notification-banner__link:visited {
color: #00703c;
}
.govuk-notification-banner--success .govuk-notification-banner__link:hover {
color: #004e2a;
}
.govuk-notification-banner--success .govuk-notification-banner__link:active {
color: #00703c;
}
.govuk-notification-banner--success .govuk-notification-banner__link:focus {
color: #0b0c0c;
}
</style>